export const CATALOG_GENERATION_STATUS = {
  Generating: 'Generating',
  Ready: 'Ready',
  Failed: 'Failed',
};

const CATALOG_GENERATION_STATUS_MAPPING = [
  { value: CATALOG_GENERATION_STATUS.Generating, label: 'Generating', color: '#FF9800' },
  { value: CATALOG_GENERATION_STATUS.Ready, label: 'Ready', color: '#4CAF50' },
  { value: CATALOG_GENERATION_STATUS.Failed, label: 'Failed', color: '#F44336' },
];

export const getCatalogGenerationStatusLabel = value =>
  CATALOG_GENERATION_STATUS_MAPPING.find(item => item.value === value)?.label ??
  (value != null && value !== '' ? String(value) : '');

export const getCatalogGenerationStatusColor = value =>
  CATALOG_GENERATION_STATUS_MAPPING.find(item => item.value === value)?.color || '#9E9E9E';
